import { ref } from 'vue';
import { defineStore } from 'pinia';

import dayjs from 'dayjs';
import posthog from 'posthog-js';

import { EevaQueryPayload } from '@eencloud/eewc-components/src/service/api-types/eeva';
import api from '@eencloud/eewc-components/src/service/api';
import {
  VSEventsDeepSearchQueryParams,
  VSEventsTimeGroupSearchRequestPayload,
  VSSearchEventsV1,
} from '@eencloud/eewc-components/src/service/api-types';

function getDefaultTimeRange() {
  const currentDateTime = new Date();
  const oneDayBeforeDateTime = dayjs(currentDateTime).subtract(1, 'days').toDate();

  return [oneDayBeforeDateTime.getTime(), currentDateTime.getTime()] as [number, number];
}

export const useEevaSettingsStore = defineStore('eevaSettings', () => {
  const loading = ref<boolean>(false);
  const defaultTimeRange = getDefaultTimeRange();
  const selectedTimeRange = ref<[number, number]>(defaultTimeRange);

  async function analyseEevaQuery(payload: EevaQueryPayload) {
    loading.value = true;
    try {
      const res = await api.analyseEevaQueries(payload);

      return res;
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  }

  async function resetTiSelectedTimerRange() {
    selectedTimeRange.value = getDefaultTimeRange();
  }

  async function getVSEventsByDeepSearch(
    params: VSEventsDeepSearchQueryParams,
    payload: VSEventsTimeGroupSearchRequestPayload,
    abortSignal?: AbortSignal
  ) {
    let events: VSSearchEventsV1[] = [];
    let pageToken: string | undefined;

    try {
      const response = await api.fetchVSEventsByDeepSearch(params, payload, abortSignal);
      if (response) {
        pageToken = response.nextPageToken;
        events = response.results || [];
      }
    } catch (error) {
      console.log(error);
    }

    return { events, pageToken };
  }

  async function captureEventForAnalytics(eventName: string, payloads?: Record<string, any>) {
    posthog.capture(eventName, {
      ...payloads,
    });
  }

  return {
    analyseEevaQuery,
    captureEventForAnalytics,
    getVSEventsByDeepSearch,
    loading,
    resetTiSelectedTimerRange,
    selectedTimeRange,
  };
});
